import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { useIsFieldInvalid } from 'components/common-form/hooks/useIsFieldInvalid';
import { usePatchedFieldHighlight } from 'components/common-form/hooks/usePatchedFieldHighlight';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { AmountInputWithLock } from 'components/shared/NewAmountInput';
import type { LockableAmountFieldMetadata } from 'models/forms/fields';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';

type LockableAmountProps = ProductNodeBuilderProps & {
  value: Nullable<number>;
  isLockedValue: boolean | null;
  onLockChanged: (locked: boolean) => void;
  onValueChanged: (value: Nullable<number>) => void;
  isDelegatedLock?: boolean;
};
export function LockableAmount({
  node: { id },
  workspaceType,
  value,
  isLockedValue,
  onLockChanged,
  isDelegatedLock,
  onValueChanged,
}: LockableAmountProps) {
  const isFieldInvalid = useIsFieldInvalid(id);
  const patchedFieldClassName = usePatchedFieldHighlight(id);
  const { currency, nbDecimals, translationKey, decimalPadding, isLocked } =
    useFieldMetadata<LockableAmountFieldMetadata>(id)!;
  const labelKey = `form.${translationKey}`;
  return (
    <BlockOrientationFormGroup
      inputId={id}
      label={labelKey as any}
      workspaceType={workspaceType}
      className={patchedFieldClassName}
    >
      <AmountInputWithLock
        isDelegated={isDelegatedLock}
        placeholderKey={labelKey as any}
        value={value}
        onValueChanged={onValueChanged}
        precision={nbDecimals}
        currency={currency}
        hasError={isFieldInvalid}
        e2e={id}
        decimalPadding={decimalPadding}
        isLocked={isLockedValue ?? isLocked}
        onLockChanged={onLockChanged}
      />
    </BlockOrientationFormGroup>
  );
}
